export const environment = {
  production: true,
  buildId: '2816116488219321',
  configFile: 'config.json',
};
